import React from 'react'

interface Props extends React.SVGProps<SVGSVGElement> {
  src: string
}

const SvgIcon: React.FunctionComponent<Props> = ({ src, ...other }) => {
  const dynamicImport = require.context(`../icons`, true, /\.svg$/)
  const IconTag = dynamicImport(`./${src}.svg`)

  return <IconTag {...other} />
}

export default SvgIcon
